export default {
  getReportList() {
    return this.http('HealthTask', 'get', '/api/v1/users/year_report');
  }
};
